// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapboxgl-popup-content {
  width: 125% !important; }

.tweet-card {
  padding: 1rem; }
  .tweet-card .tweet-bottom p {
    color: #fff; }

.tweet-top {
  display: flex; }
  .tweet-top img {
    margin-right: 8px; }
  .tweet-top h4 {
    margin-bottom: 0; }
    .tweet-top h4 a {
      text-decoration: none; }

.tweet-bottom {
  margin-top: 10px; }
  .tweet-bottom .tweet-link {
    text-decoration: none !important;
    color: white;
    font-weight: 500; }
    .tweet-bottom .tweet-link p {
      color: white; }

.tweet-name {
  font-size: 11.172px;
  font-weight: bold; }

.tweet-handle {
  font-size: 9.408px; }

.tweet-date {
  font-size: 11px;
  color: #8e8e8e;
  font-weight: 500; }

.tweet-x {
  width: 24px;
  font-size: 24px;
  background-color: white;
  padding: 0px;
  border-radius: 4px;
  color: black;
  cursor: pointer; }

.cluster-marker {
  color: #fff;
  background: black;
  border: 4px solid white;
  border-radius: 50%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center; }

.nav-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  margin: 0px;
  padding-top: 0px; }

.tweet-paginate-btn {
  color: white;
  background: none;
  border: none; }

.mapboxgl-popup-tip {
  border-top-color: #18244c !important; }
`, "",{"version":3,"sources":["webpack://./src/components/tweet-list/tweet-list.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB,EAAA;;AAGxB;EACE,aAAa,EAAA;EADf;IAIM,WAAW,EAAA;;AAKjB;EACE,aAAa,EAAA;EADf;IAII,iBAAiB,EAAA;EAJrB;IAQI,gBAAgB,EAAA;IARpB;MAUM,qBAAqB,EAAA;;AAK3B;EACI,gBAAgB,EAAA;EADpB;IAGQ,gCAAgC;IAChC,YAAY;IACZ,gBAAgB,EAAA;IALxB;MAMY,YAAa,EAAA;;AAIzB;EACE,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe,EAAA;;AAKjB;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,gBAAgB,EAAA;;AAGpB;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY,EAAA;;AAGd;EACE,oCAAoC,EAAA","sourcesContent":[".mapboxgl-popup-content {\n  width: 125% !important;\n}\n\n.tweet-card {\n  padding: 1rem;\n  .tweet-bottom {\n    p {\n      color: #fff;\n    }\n  }\n}\n\n.tweet-top {\n  display: flex;\n\n  img {\n    margin-right: 8px;\n  }\n\n  h4 {\n    margin-bottom: 0;\n    a {\n      text-decoration: none;\n    }\n  }\n}\n\n.tweet-bottom {\n    margin-top: 10px;\n    .tweet-link { \n        text-decoration: none !important;\n        color: white;\n        font-weight: 500; \n        p { color: white }\n    }\n}\n\n.tweet-name {\n  font-size: 11.172px;\n  font-weight: bold;\n}\n\n.tweet-handle {\n  font-size: 9.408px;\n}\n\n.tweet-date {\n  font-size: 11px;\n  color: #8e8e8e;\n  font-weight: 500;\n}\n\n.tweet-x {\n  width: 24px;\n  font-size: 24px;\n  background-color: white;\n  padding: 0px;\n  border-radius: 4px;\n  color: black;\n  cursor: pointer;\n}\n\n// Clusters\n\n.cluster-marker {\n  color: #fff;\n  background: black;\n  border: 4px solid white;\n  border-radius: 50%;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.nav-box {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px;\n    margin: 0px;\n    padding-top: 0px;\n}\n\n.tweet-paginate-btn {\n  color: white;\n  background: none;\n  border: none;\n}\n\n.mapboxgl-popup-tip {\n  border-top-color: #18244c !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
